<title>Autoverkoop Partner - Bod accepteren</title>

<!-- Page Content -->
<div class="container">
  <div class="card border-0 shadow my-5">
    <div class="card-body p-5">
      <img class="img-fluid header-img" src="/assets/images/avp-logo.png">
      <hr>

        <h1 class="font-weight-light">Bod accepteren</h1>

        @if (valuationData) {
          <p class="lead">
            We hebben jouw {{valuationData.VehicleSpecification.Vehicle.make}}
            {{valuationData.VehicleSpecification.Vehicle.modelSpecific}} met kenteken
            {{valuationData.VehicleSpecification.Vehicle.registration | licensePipe:
            valuationData.VehicleSpecification.Vehicle.registration}} getaxeerd! <br> Ons team heeft zijn best
            gedaan en wij kopen de auto graag van je voor <b style="font-weight:bold;">€ {{valuationData.dgwAmount | number: '1.0-0'}}</b>.
          </p>
        }

        <form [formGroup]="validationForm" class="needs-validation">
          <div class="form-group">
            <label><b>Naam</b></label>
            <div class="row">
              <div class="form-group col">
                <input formControlName="firstName" type="text" class="form-control" placeholder="Voornaam"
                  [ngClass]="{ 'is-invalid': submitted && f.firstName.errors }">
                @if (submitted && f.firstName.errors) {
                  <div class="invalid-feedback">
                    @if (f.firstName.errors.required) {
                      <div>Voornaam is een verplicht veld</div>
                    }
                    @if (f.firstName.errors.minlength) {
                      <div>Geen geldige voornaam</div>
                    }
                  </div>
                }
              </div>
              <div class="form-group col-md-2">
                <input formControlName="infix" type="text" class="form-control" placeholder="Tussenvoegsel">
              </div>
              <div class="form-group col">
                <input formControlName="lastName" type="text" class="form-control" placeholder="Achternaam"
                  [ngClass]="{ 'is-invalid': submitted && f.lastName.errors }">
                @if (submitted && f.firstName.errors) {
                  <div class="invalid-feedback">
                    @if (f.lastName.errors.required) {
                      <div>Achternaam is een verplicht veld</div>
                    }
                    @if (f.lastName.errors.minlength) {
                      <div>Geen geldige achternaam</div>
                    }
                  </div>
                }
              </div>
            </div>

            <div class="row">
              <div class="form-group col">
                <input formControlName="phoneNumber" type="text" class="form-control"
                  placeholder="Mobiel telefoonnummer (0612345678)"
                  [ngClass]="{ 'is-invalid': submitted && f.phoneNumber.errors }">
                @if (submitted && f.phoneNumber.errors) {
                  <div class="invalid-feedback">
                    @if (f.phoneNumber.errors.required) {
                      <div>Telefoonnummer is een verplicht veld</div>
                    }
                    @if (f.phoneNumber.errors.minlength) {
                      <div>Geen geldig telefoonnummer</div>
                    }
                  </div>
                }
              </div>
            </div>
            <small class="form-text text-muted">
              <fa-icon class="secure-lock" [icon]="faLock"></fa-icon> Geen zorgen, wij delen je gegevens met
              niemand anders.
            </small>
          </div>

          <div class="form-group">
            <div class="form-check">
              <input formControlName="agreement" type="checkbox" class="form-check-input" id="exampleCheck1"
                [ngClass]="{ 'is-invalid': submitted && f.agreement.errors }">
              <label class="form-check-label" for="exampleCheck1">Bovenstaande gegevens heb ik correct
                ingevoerd en ik ga akkoord met de <a target="_blank" href="https://autoverkooppartner.nl/wp-content/uploads/2021/03/Algemene-Voorwaarden-AVP-1.0.pdf">voorwaarden</a>.</label>
                @if (submitted && f.agreementBid.errors) {
                  <div class="invalid-feedback">
                    @if (f.agreement.errors.required) {
                      <div>Je bent niet akkoord gegaan met de voorwaarden.
                      </div>
                    }
                  </div>
                }
              </div>
            </div>

            <div class="form-group">
              <div class="form-check">
                <input formControlName="agreementBid" type="checkbox" class="form-check-input"
                  id="exampleCheck2" [ngClass]="{ 'is-invalid': submitted && f.agreementBid.errors }">
                <label class="form-check-label" for="exampleCheck2">Ik ga akkoord met het gegarandeerde
                bod.</label>
                @if (submitted && f.agreementBid.errors) {
                  <div class="invalid-feedback">
                    @if (f.agreementBid.errors.required) {
                      <div>Je bent niet akkoord gegaan met het bod.</div>
                    }
                  </div>
                }
              </div>
            </div>

            <div class="row">
              <div class="col-md-6 form-group">
                <button id="accept-btn" (click)="onSubmit()" class="btn btn-primary form-group" type="submit">Accepteer
                bod</button>
              </div>
            </div>
          </form>
          <div style="height: 700px"></div>
        </div>
      </div>
    </div>